import { Component, Input } from '@angular/core';

@Component({
  selector: 'go-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() public showLanguageSelection = true;

  constructor() {
  }

}
